import { useEffect, useState } from "react";
import { createGlobalStore } from "hox";
import CONST from "@/config/const.js";
import { useSize, useDebounce, useRequest } from "ahooks";
import cookie from "@/utils/cookie";
import service from "@/services/pagemode";
import QRCode from "qrcode";

const getLan = () => {
  var matchList = window.location.href.match(/[a-z]+_[A-Z]+/);
  var lan = matchList && matchList.length > 0 ? matchList[0] : "en_US";
  return lan;
};
export const [usePageMode, getPageMode] = createGlobalStore(() => {
  const [mode, setMode] = useState(
    cookie.read("cusSkin") == 1 || !cookie.read("cusSkin") ? "dark" : "light"
  ); // 1 dark， 2 light
  const [lang, setLang] = useState(cookie.read("lan") || getLan());
  const [curr_rate, setCurrRate] = useState(cookie.read("curr_rate") || "USD");
  const [appdownload, setDownloadInfo] = useState({});

  const size = useSize(window.document.documentElement);
  const sizeDebounce = useDebounce(size, { wait: 20 });

  function changePageMode(task) {
    cookie.write("cusSkin", task == "light" ? 2 : 1);
    setMode(task);
  }
  function changeLang(task) {
    let item = CONST.langList.find((item) => item.id == task);
    if (item) {
      cookie.write("lan", task);
      setLang(task);
      let pathname = window.location.pathname.split("/");
      pathname[1] = task;
      window.location.href = pathname.join("/") + window.location.search;
    }
  }
  function changeRate(longKey) {
    cookie.write("curr_rate", longKey);
    setCurrRate(longKey);
  }

  const { loading, runAsync } = useRequest(service.appdownload, {
    manual: true,
  });
  const getDownload = async () => {
    try {
      const res = await runAsync({
        payload: {},
      });

      if (res.code == 0) {
        let obj = res.data;
        obj.app_page_url = await QRCode.toDataURL(obj.download_serve_url);
        setDownloadInfo(obj);
      }
    } catch (e) {
      console.error(e);
    }
  };
  useEffect(() => {
    getDownload();
    if (!cookie.read("cusSkin")) {
      cookie.write("cusSkin", 1);
    }
    if (!cookie.read("lan")) {
      cookie.write("lan", getLan());
    }
  }, []);
  return {
    mode,
    lang,
    curr_rate,
    changePageMode,
    changeLang,
    changeRate,
    bodySize: sizeDebounce,
    appdownload,
  };
});
